/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CohortState } from './cohortState';

export type CohortUpdateRequestState = CohortState | null;
